var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.923 31.294"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.852 0A.852.852 0 000 .856v29.556a.854.854 0 001.708 0v-28.7h16.514v28.7a.852.852 0 101.7 0V.856A.853.853 0 0019.07 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.961 20.597a.859.859 0 00-.6.248l-9.1 9.012a.833.833 0 000 1.188.861.861 0 001.2 0l8.5-8.417 8.5 8.417a.861.861 0 001.209 0 .834.834 0 000-1.188l-9.109-9.012a.859.859 0 00-.6-.248z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M13.996 11.093H5.928"
  })));
}
export default SvgBookmarkRemove;